export default __webpack_public_path__ + "static/media/Blend-on.6a3e6f12.svg";